import { render } from "./MediosPago.vue?vue&type=template&id=17ead58a"
const script = {}

import "./MediosPago.vue?vue&type=style&index=0&id=17ead58a&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__